import { GetBaseUrl } from "@/utils/ConfigHelper";
import axios from "axios";
import Response from "@/utils/Videomonster/Common/Response";
import { PUBLIC_ERROR_CODE } from "@/utils/Error/Constants";
import { GetPublicErrorCode } from "@/utils/Error/Handler";
import { fileUtils } from "@/utils/AiTool";

/**
 *  @param {String} token
 *  @param {{
 *    base64: string,
 *    ext: string,
 *  }} data
 *  @throws {Error}
 *  @returns {Promise<Response>}
 */

const PostShortsBeginDownload = async (token, data) => {
  try {
    const url = `${GetBaseUrl()}/apis/shorts/analysis/begin-download`;
    const response = await axios.post(
      url,
      { url: data.url },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    const result = response.status === 200;
    const resultData = response.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_NOT_ENOUGH_POINT:
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
};

const GetShortsAnalysisMetadata = async (token, data) => {
  try {
    const { analysisId } = data;
    const url = `${GetBaseUrl()}/apis/shorts/analysis/${analysisId}`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const GetShortsAnalysisState = async (token, data) => {
  try {
    const { analysisId } = data;
    const url = `${GetBaseUrl()}/apis/shorts/analysis/${analysisId}/state`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    /*
      {
          "shortsAnalysis": {
              "_id": "6800ea2383cdbb006222ea5d",
              "state": "Finish",
              "analysisState": {
                  "currentStep": 6,
                  "totalStep": 6
              }
          }
      }
    */

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const GetShortsAnalysisList = async (token, data) => {
  try {
    const { shortsType, offset, limit } = data;
    const url = `${GetBaseUrl()}/apis/shorts/analysis`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: { shortsType, offset, limit }
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    /*
      {
        "list": [
            {
                "_id": "680488da4fd5650062247fd1",
                "url": "https://www.youtube.com/watch?v=Ku3MmQhsBLQ",
                "shortsType": "YoutubeUrlToShorts",
                "state": "Error",
                "lang": null,
                "shortsMetadata": {},
                "analysisInputData": {},
                "analyzeStartDate": null,
                "createdDate": "2025-04-20T05:40:42.184Z",
                "updatedDate": "2025-04-20T05:40:47.226Z"
            },
            {
                "_id": "68047820b028b80062197429",
                "url": "https://www.youtube.com/watch?v=NKIQHDuLyYk",
                "shortsType": "YoutubeUrlToShorts",
                "state": "Finish",
                "lang": "ko",
                "shortsMetadata": {
                    "metadataJsonUrl": "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/metadata.json",
                    "sourceType": "youtube",
                    "yid": "NKIQHDuLyYk",
                    "audioUrl": "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/audio.m4a",
                    "videoUrl": "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/video.mp4",
                    "previewImageUrl": {
                        "url": "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/preview-images/preview-%7BFRAME%7D.jpg",
                        "totalFrames": 467
                    }
                },
                "analysisInputData": {
                    "endTime": 600,
                    "layout": "Layout01",
                    "mode": "FullAnalysis",
                    "startTime": 0,
                    "splittedAudioUrls": [
                        "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/split-audio-0.m4a",
                        "https://videomonsterpublicdevnew.blob.core.windows.net/00youtubeshorts/68047820b028b80062197429/split-audio-1.m4a"
                    ]
                },
                "analyzeStartDate": "2025-04-20T04:29:50.272Z",
                "createdDate": "2025-04-20T04:29:20.744Z",
                "updatedDate": "2025-04-20T04:31:15.726Z",
                "analysisState": {
                    "currentStep": 6,
                    "totalStep": 6
                }
            },
        ],
        "count": 168
    }
    */
    
    return new Response(result, resultData);
  }
  catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const PostShortsBeginAnalysis = async (token, data) => {
  try {
    const {
      analysisId,
      startTime,
      endTime,
      mode,
      layout,
    } = data;
    const url = `${GetBaseUrl()}/apis/shorts/analysis/${analysisId}/begin-analysis`;
    const response = await axios.post(
      url,
      {
        startTime,
        endTime,
        mode,
        layout
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    const result = response.status === 200;
    const resultData = response.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_NOT_ENOUGH_POINT:
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
};

const PostShorts = async (token, data) => {
  try {
    const {
      analysisId,
      analysisIndex,
      name
    } = data;
    const url = `${GetBaseUrl()}/apis/shorts`;
    const response = await axios.post(
      url,
      {
        analysisId,
        analysisIndex,
        name
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    const result = response.status === 200;
    const resultData = response.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_NOT_ENOUGH_POINT:
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
};

const GetShortsList = async (token, data) => {
  try {
    const { offset, limit, sort } = data;
    const url = `${GetBaseUrl()}/apis/shorts`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: { offset, limit, sort }
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    /*
        "list" : [
          {
            "_id": "67ef4c772776be7e7255aceb",
            "type": "YoutubeUrlToShorts",
            "userId": "5c8f17db5348a10022ef4742",
            "analysisId": "67ef4ace6686194f41ea7e0f",
            "name": "닭가슴살 돈까스를 맛있게 먹는 비법",
            "layout": "Layout01",
            "state": "Waiting",
            "url": null,
            "thumbnailURL": null,
            "log": null,
            "rendered": false,
            "meterial": null,
            "setStateDate": "2025-04-04T03:05:27.939Z",
            "createdDate": "2025-04-04T03:05:27.939Z",
            "updatedDate": "2025-04-04T03:05:27.939Z"
          }
        ],
        "count": 1
    */

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const GetShortsItem = async (token, data) => {
  try {
    const { shortsId } = data;
    const url = `${GetBaseUrl()}/apis/shorts/${shortsId}`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    /*
        "item" : {
          "_id": "67ef4c772776be7e7255aceb",
          "type": "YoutubeUrlToShorts",
          "userId": "5c8f17db5348a10022ef4742",
          "analysisId": "67ef4ace6686194f41ea7e0f",
          "name": "닭가슴살 돈까스를 맛있게 먹는 비법",
          "layout": "Layout01",
          "state": "Waiting",
          "url": null,
          "thumbnailURL": null,
          "log": null,
          "rendered": false,
          "meterial": null,
          "setStateDate": "2025-04-04T03:05:27.939Z",
          "createdDate": "2025-04-04T03:05:27.939Z",
          "updatedDate": "2025-04-04T03:05:27.939Z"
        }
    */

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const IsExistsShorts = async (token, data) => {
  try {
    const { analysisId, analysisIndex } = data;
    const url = `${GetBaseUrl()}/apis/shorts/exists`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: { analysis_id: analysisId, analysis_index: analysisIndex }
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    /*
        "isExists" : true
    */

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const PatchShorts = async (token, data) => {
  try {
    const { shortsId, name, layout, material } = data;

    const url = `${GetBaseUrl()}/apis/shorts/${shortsId}`;
    const response = await axios.patch(url, { name, layout, material }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const result = response.status === 200;
    const resultData = response.data;

    return new Response(result, {});
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        return new Response(false, PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR);
    }
  }
}

const DeleteShorts = async (token, data) => {
  try {
    const { shortsId } = data;

    const url = `${GetBaseUrl()}/apis/shorts/${shortsId}`;
    const response = await axios.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const result = response.status === 200;

    return new Response(result, {});
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const PostRenderingShorts = async (token, data) => {
  try {
    const { shortsId, renderingData } = data;

    const url = `${GetBaseUrl()}/apis/shorts/${shortsId}/rendering-json`;
    const response = await axios.post(url, { data: renderingData }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const result = response.status === 200;

    return new Response(result, {});
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

export default {
  PostShortsBeginDownload,
  GetShortsAnalysisMetadata,
  GetShortsAnalysisState,
  GetShortsAnalysisList,
  PostShortsBeginAnalysis,

  PostShorts,
  GetShortsList,
  GetShortsItem,
  IsExistsShorts,
  PatchShorts,
  DeleteShorts,

  PostRenderingShorts
};